import { render, staticRenderFns } from "./prepareSettle.vue?vue&type=template&id=b72020c4&scoped=true&"
import script from "./prepareSettle.vue?vue&type=script&lang=js&"
export * from "./prepareSettle.vue?vue&type=script&lang=js&"
import style0 from "./prepareSettle.vue?vue&type=style&index=0&id=b72020c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72020c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b72020c4')) {
      api.createRecord('b72020c4', component.options)
    } else {
      api.reload('b72020c4', component.options)
    }
    module.hot.accept("./prepareSettle.vue?vue&type=template&id=b72020c4&scoped=true&", function () {
      api.rerender('b72020c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopSettle/prepareSettle.vue"
export default component.exports